export default "__VITE_ASSET__2260b9b5__"